<template>
  <div class="h-dialogContainer">
    <div>
      <MemberInfoCommon ref="memeberConfigInfo" opCode="addMemeber" impugrpclassIndex="4" impugrppriorityIndex="5" grppropertyIndex="6" :msgid="msgid" :neid="neid"></MemberInfoCommon>
    </div>
    <div class="h-borderBox">
      <div class="h-subscriber-member-qryParamDiv">
        <div class='row h-row-inputBox'>
          <form :id="formId">
            <div class='col-sm-3 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('SubscriberIms.userNo')}}:</div>
              <div><ejs-textbox  ref="usernumParam" name="usernum"></ejs-textbox></div>
            </div>
            <div class='col-sm-3 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('SubscriberIms.userName')}}:</div>
              <div><ejs-textbox  ref="usernameParam" name="username"></ejs-textbox></div>
            </div>
            <div class='col-sm-3 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('SubscriberIms.vpnid')}}:</div>
              <div><ejs-textbox  ref="vpnidParam" name="vpnid" disabled="true" v-model="vo.vpnid"></ejs-textbox></div>
              <div class='h-subscribe-select-style'>
                <ejs-button :isPrimary="true" @click.native="selectVpn">{{$t('SubscriberIms.selectVButton')}}</ejs-button>
              </div>
            </div>
          </form>
          <div class='col-sm-3'>
            <div class='h-inputLit'></div>
            <div class='h-subscriber-member-qryButton'>
              <ejs-button :isPrimary="true" @click.native="qryDialog">{{$t('SubscriberIms.find')}}</ejs-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-subscribe-height-415">
      <ejs-grid ref='grid' :dataSource="data" :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowPaging='true' :pageSettings="page" height="320">
        <e-columns>
          <e-column textAlign='Center' :headerText="$t('SubscriberIms.userInfo')" :columns="userInfoColumns"></e-column>
          <e-column textAlign='Center' minWidth='300px' :headerText="$t('SubscriberIms.lsgxInfo')" :columns="memberInfoColumns"></e-column>
          <!--<e-column type='checkbox' :headerText="$t('SubscriberIms.userNo')" width='40' textAlign='Center'></e-column>-->
          <!--<e-column field='impu' :headerText="$t('SubscriberIms.userNo')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='username' :headerText="$t('SubscriberIms.userName')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='rtttype' :headerText="$t('SubscriberIms.rtttype')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="rtttypeFormat"></e-column>-->
          <!--<e-column field='regstatus' :headerText="$t('SubscriberIms.regstatus')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="regstatusFormat"></e-column>-->
          <!--<e-column field='createtime' :headerText="$t('SubscriberIms.createtime')" width='150' format='yyyy-MM-dd hh:mm:ss' type='dateTime' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='impugrpclass' :headerText="$t('SubscriberIms.impugrpclass')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="impugrpclassFormat"></e-column>-->
          <!--<e-column field='impugrppriority' :headerText="$t('SubscriberIms.impugrppriority')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='grpproperty' :headerText="$t('SubscriberIms.grpproperty')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="grppropertyFormat"></e-column>-->
          <e-column field='impugrpclass_hidden' :visible='false'></e-column>
        </e-columns>
      </ejs-grid>
      </div>
      <ejs-pager ref="grpMemberPager"  @click='getGridData(node,qryParamBak)' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount'></ejs-pager>
    </div>
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.eleQryVpnInfo' :styles='dialog.stylesWithIndex'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata"></OrganizationalTree>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import MemberInfoCommon from '../../MemberInfoCommon';
import CustomDialog from '../../../../common/CustomDialog';
import OrganizationalTree from '../../../util/OrganizationalTree';
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'AddGroupMemberDialog',
  components: {
    MemberInfoCommon,
    CustomDialog,
    OrganizationalTree,
  },
  props: [
    'opCode',
    'msgid',
    'neid',
    'node',
  ],
  data() {
    return {
      data: {},
      qryParamBak:undefined,
      validateObj: undefined,
      vpndata: [],
      formId: 'qryFormId',
      memberInfo: {},
      checkedData: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: '0',
        pageCount: '0',
      },
      info: {
        msgid: '',
        neid: '',
        netype: 'p_hss',
        neversion: ''
      },
      vo: {
        flag: '',
        vpnid: '',
        vpnClass: ''
      },
      chooseCount: 0,
      typeEnum: {
        rtttype: {
          2: this.$t('SubscriberIms.rtttype2'),
          4: this.$t('SubscriberIms.rtttype4'),
          5: this.$t('SubscriberIms.rtttype5'),
          6: this.$t('SubscriberIms.rtttype6'),
          8: this.$t('SubscriberIms.rtttype8'),
        },
        regstatus: [this.$t('SubscriberIms.unregister'), this.$t('SubscriberIms.register')]
      },
      userInfoColumns: [
        { type: 'checkbox', width: '30', headerText: this.$t('SubscriberIms.userNo'), minWidth: 30, textAlign: 'Center' },
        { field: 'impu', width: '50', headerText: this.$t('SubscriberIms.userNo'), minWidth: 20, textAlign: 'Center', clipMode: 'EllipsisWithTooltip' },
        { field: 'username', width: '60', headerText: this.$t('SubscriberIms.userName'), minWidth: 20, textAlign: 'Center', clipMode: 'EllipsisWithTooltip' },
        { field: 'rtttype', width: '60', headerText: this.$t('SubscriberIms.rtttype'), minWidth: 20, textAlign: 'Center', clipMode: 'EllipsisWithTooltip', formatter: this.rtttypeFormat },
        // { field: 'regstatus', headerText: this.$t('SubscriberIms.regstatus'), minWidth: 10, textAlign: 'Center', clipMode: 'EllipsisWithTooltip', formatter: 'regstatusFormat' },
        // { field: 'createtime', headerText: this.$t('SubscriberIms.createtime'), minWidth: 10, textAlign: 'Center', clipMode: 'EllipsisWithTooltip',type: 'dateTime', format: 'yyyy-MM-dd hh:mm:ss' },
      ],
      memberInfoColumns: [
        { field: 'impugrpclass', width: '200', headerText: this.$t('SubscriberIms.impugrpclass'), minWidth: 200, textAlign: 'Center', clipMode: 'EllipsisWithTooltip', formatter: this.impugrpclassFormat },
        { field: 'impugrppriority', width: '70', headerText: this.$t('SubscriberIms.impugrppriority'), minWidth: 10, textAlign: 'Center', clipMode: 'EllipsisWithTooltip' },
        { field: 'grpproperty', width: '70', headerText: this.$t('SubscriberIms.grpproperty'), minWidth: 10, textAlign: 'Center', clipMode: 'EllipsisWithTooltip', formatter: this.grppropertyFormat },
      ],
      dialog: {
        eleQryVpnInfo: {
          target: this.$refs.qryVpnInfoPage,
          refName: 'qryVpninfo',
          buttonGroup: [
            {
              click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
            },
            {
              click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
            }
          ],
          title: this.$t('SubscriberIms.organization'),
          isClose: true
        },
        stylesWithIndex: {
          width: '20%',
          height: '48%',
          visible: false,
          model: true,
          zIndex: 1000,
        },
      }
    };
  },
  methods: {
    mainHandler() {
      this.bindValidate();
      console.log(this.$refs.memeberConfigInfo, new Date());
      this.$refs.memeberConfigInfo.mainHandler([], { opCode: 'add' }, true);
      console.log(this.$parent.$parent.$parent.$parent.$children[0]);
      const vpntree = this.$parent.$parent.$parent.$parent.$children[0];
      this.vpndata = vpntree.initData;
      // const vpntree = this.$parent.$parent.$refs.addGroupMember.$parent.$parent.$parent.$parent.$refs.organizationalTree;
      // console.log("=======================", vpntree.$refs.tree1.getNode('7_7_1'));
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false ? this.$refs.base.validateResult() : true;
      if (!validateReturn) {
        console.log('表单验证不通过');
        return;
      }
      const map = this.$refs.base.getDatas();
      // 隶属关系完整数据
      console.log(map);
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    getCheckedData() {
      const userList = this.$refs.grid.getSelectedRecords();
      const memberInfo = this.$refs.memeberConfigInfo.getMemberInfo();
      const grppropertyMap = memberInfo.get('grpproperty').valueMap;
      const map = new Map();
      console.log(grppropertyMap);
      userList.map(item => {
        // item.grpproperty = grppropertyMap.get();
        console.log(item.grpproperty);
      })
      return userList;
    },
    initAnotherBussinessDatas(datas) {
      datas.confirmpassword = datas.password;
    },
    qryDialog() {
      console.log('向后台查询数据拉');
      if (!this.checkValid()) {
        return;
      }
      console.log("this.vo.vpnClass", this.vo.vpnClass);
      const param = {
        impu: this.$refs.usernumParam.ej2Instances.value,
        username: this.$refs.usernameParam.ej2Instances.value,
        vpnid: this.$refs.vpnidParam.ej2Instances.value,
        vpnClass: this.vo.vpnClass === undefined ? 0 : parseInt(this.vo.vpnClass, 10) - 1,
        rtttype: -1,
        userenable: -1,
      };
      this.qryParamBak = param;
      this.getGridData(this.node, param,true);
    },
    getGridData(node, qryParam = undefined, searchFlag = false) {
      console.log(new Date(), this.$refs.memeberConfigInfo.getMemberInfo());
      const $this = this;
      const memeberinfo = $this.$refs.memeberConfigInfo.getMemberInfo();
      if (node !== '') {
        $this.node = node;
        const array = node.id.split('_');
        const neid = array[0];
        // const vpnid = array[2];
        $this.info.neid = neid;
        $this.info.vpnid = 0;
        $this.info.vpnname = node.text;
        $this.info.msgid = '27836';
        //const vpnclass = this.vo.vpnClass === undefined ? 0 : parseInt(this.vo.vpnClass, 10) - 1;
        //$this.info.vpnClass = vpnclass;
        // $this.vo.vpnid = 0;
        // $this.vo.vpnClass = vpnclass;
        $this.vo.flag = 0;
        $this.vo.vpnname = node.text;
        const paramVo = JSON.parse(JSON.stringify($this.vo));
        if (qryParam !== undefined) {
          paramVo.flag = 2;
          for (const _param in qryParam) {
            paramVo[_param] = qryParam[_param];
          }
          if(searchFlag)
            $this.page.pageNo = 1;
          else
            $this.page.pageNo = $this.$refs.grpMemberPager.ej2Instances.currentPage;
        } else {
          $this.page.pageNo = $this.$refs.grpMemberPager.ej2Instances.currentPage;
        }
        const paramTotal = {
          vo: paramVo,
          info: {
            msgid: 27836,
            neid: $this.neid
          },
          page: $this.page
        };
        // const pageInfo = { pageNo: $this.page.pageNo, pageSize: $this.page.pageSize };
        // 需要拼装vo info
        // this.$axios.post('lte/ems/ims/subscriber/requestCommon', $this.getParams(pageInfo)).then((response) => {
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramTotal).then((response) => {
          const res = response.data.resultVal;
          console.log(res);
          if (res.resultList === undefined) {
            $this.data = [];
            $this.page.pageCount = 0;
            $this.page.totalCount = 0;
            $this.page.pageCount = 0;
            return;
          }
          res.resultList.forEach(item => {
            item.impugrpclass_hidden = [1, 1, 1];
            item.impugrppriority = 0;
            item.grpproperty = 3;
            if (item.createtime) {
              const time = item.createtime * 1000;
              item.createtime = time;
            }
          });
          $this.data = res.resultList;
          // $this.page.pageCount = res.page;
          $this.page.totalCount = res.countrsp;
          // $this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
        });
      } else {
        $this.info.neid = '';
        $this.info.vpnid = '';
        $this.info.vpnname = '';
      }
    },
    rtttypeFormat(grids, data) {
      // 暂时先写死，后续根据添加的json，处理此字段
      console.log(data.rtttype, this.typeEnum.rtttype[2]);
      // console.log(this.typeEnum.rtttype.get(data.rtttype));
      return this.typeEnum.rtttype[data.rtttype];
    },
    regstatusFormat(grids, data) {
      // console.log(this.typeEnum.regstatus[data.regstatus]);
      return this.typeEnum.regstatus[data.regstatus];
    },
    impugrpclassFormat(grids, data) {
      // 需要做特殊处理
      if (data.impugrpclass === undefined) {
        data.impugrpclass = 7;
      }
      return this.$refs.memeberConfigInfo.impugrpclassShow(data.impugrpclass);
    },
    grppropertyFormat(grids, data) {
      const grpprop = this.$refs.memeberConfigInfo.getMemberInfo().get('grpproperty').valueMap;
      return data.grpproperty === undefined ? '' : grpprop.get(data.grpproperty.toString());
    },
    checkValid() {
      const checkStatus = this.validateObj.validate();
      return checkStatus;
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          usernum: {
            regex: ['^\\d*$',this.$t('SubscriberIms.invalidInt')],
            range: [[0, 99999999], this.$t('SubscriberIms.grpnumrange')],
          },
          username: {
            regex: ['^[_0-9a-zA-Z\u4E00-\u9FA5]+$', this.$t('SubscriberIms.invalideChar')],
            maxLength: [15,this.$t('SubscriberIms.maxlen15')],
          },
          vpnid: {
            regex: ['^\\d*$', this.$t('SubscriberIms.invalidInt')],
            range: [[0, 99999999], this.$t('SubscriberIms.grpnumrange')],
          }
        },
      };
      this.validateObj = new FormValidator(`#${this.formId}`, validationOption);
    },
    selectVpn() {
      // 组织架构查询赋值
      this.$refs.qryVpnInfoPage.show();
      console.log('vpndata', this.vpndata);
      this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
      this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
      this.selectFlag = true;
      return false;
    },
    /**
     * 更新和关闭组织架构
     */
    setChooseVpnInfo(event) {
      if (event.keyCode === 13) {
        return;
      }
      const selectNode = this.$refs.organizationalTreeInner.getNode();
      if (!selectNode) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseNodeTip') });
      } else {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();

        this.vo.vpnid = selectNode.id.split('_')[2];
        this.vo.vpnClass = selectNode.level;
      }
    },
    closeQryVpnInfoPage() {
      this.$refs.organizationalTreeInner.clear();
      this.$refs.qryVpnInfoPage.clear();
      this.$refs.qryVpnInfoPage.close();
    }
  },
};
</script>
<style scoped>

</style>
